import ClaimSetCreatedEvent from '@/domains/claimSets/events/ClaimSetCreatedEvent';
import ClaimSetReportedEvent from '@/domains/claimSets/events/ClaimSetReportedEvent';

const ClaimSetEvents = {
  Created: ClaimSetCreatedEvent,
  Reported: ClaimSetReportedEvent,
};

export default ClaimSetEvents;
